export { default as WysiwygHtmlArea } from "./WysiwygHtmlArea.vue";